import { BottomSheetDialog } from '@medely/web-components';
import { W2InterestDialogProps } from './interface';
import React from 'react';
import useDevice from '@mp/hooks/useDevice.web';
import { W2InterestFormFields } from './W2InterestFormFields';
import { Button } from '@medely/ui-kit';
import { useW2Interest } from '@mp/hooks/useW2Interest';
import { useW2interestEvent } from '@mp/hooks';
import { useWatch } from '@medely/ui-kit/react-hook-form';

export const W2InterestDialog = ({ open, onClose }: W2InterestDialogProps) => {
  const isDesktop = useDevice() === 'desktop';
  const { setW2Interest, isLoading: isW2Loading } = useW2Interest();
  const { trackW2InterestCardClick } = useW2interestEvent();

  const value = useWatch({ name: 'w2_interest' });

  const handleSave = () => {
    trackW2InterestCardClick();
    setW2Interest(value === 1 ? true : false);
    onClose();
  };

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      title="W-2 interest"
      sx={{ alignSelf: isDesktop ? 'center' : 'end' }}
      content={<W2InterestFormFields />}
      actions={
        <Button disabled={isW2Loading} loading={isW2Loading} fullWidth onClick={handleSave}>
          Save
        </Button>
      }
      isDesktop={isDesktop}
    />
  );
};
